import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonos = [{
  num: '01',
  title: 'KIT DE ARRANQUE RÁPIDO IA FITNESS',
  desc: 'Ecosistema digital activo en menos de 60 minutos. Configuración paso a paso + 5 prompts iniciales listos para usar hoy.',
  value: '$15.000'
}, {
  num: '02',
  title: 'BIBLIOTECA EXPRESS DE PROMPTS',
  desc: '25+ prompts específicos para planes, recetas, listas de compras y seguimientos. Copiar, pegar y ejecutar. Sin improvisar nunca más.',
  value: '$18.000'
}, {
  num: '03',
  title: 'PLANTILLAS PRO PARA ENTREGAR PLANES',
  desc: 'Estructuras visuales premium para que tus planes se vean de alto valor desde el primer cliente. Templates listos para Canva.',
  value: '$12.000'
}, {
  num: '04',
  title: 'CHECKLIST MAESTRA DE CREACIÓN Y ENTREGA',
  desc: '22 checklists que cubren cada etapa del proceso. Desde el intake hasta el seguimiento. Versión imprimible de uso diario.',
  value: '$12.000'
}, {
  num: '05',
  title: 'RESPUESTAS RÁPIDAS IA PARA CLIENTES',
  desc: '30+ mensajes listos para WhatsApp Business. Precios, objeciones, seguimientos y cierres. Activalos en segundos con una palabra clave.',
  value: '$10.000'
}, {
  num: '06',
  title: 'PACK DE RECURSOS DESCARGABLES',
  desc: 'Trackers, planificadores y mini templates para organizar clientes, producción, contenido y ventas semana a semana.',
  value: '$10.000'
}];
export function BonosSection() {
  return <section className="py-14 relative" data-id="element-17">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-18"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-20">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-gold via-yellow-400 to-gold rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-21"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-gold rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-gold/30" data-id="element-22">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(232,184,74,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(232,184,74,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-23"></div>

            {/* Corner ribbons */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-gold rounded-tl-3xl pointer-events-none" data-id="element-24"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-gold rounded-tr-3xl pointer-events-none" data-id="element-25"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-gold rounded-bl-3xl pointer-events-none" data-id="element-26"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-gold rounded-br-3xl pointer-events-none" data-id="element-27"></div>

            <div className="relative z-10" data-id="element-28">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-gold text-graphite border border-gold px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-gold/40" data-id="element-29">
                <Gift className="w-3.5 h-3.5" data-id="element-30" />
                Regalo Exclusivo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 md:gap-4 flex-wrap" data-id="element-31">
                <Gift className="w-8 h-8 md:w-10 md:h-10 text-gold drop-shadow-[0_0_8px_rgba(232,184,74,0.6)]" data-id="element-32" />
                <span className="text-white" data-id="element-33">6 BONOS</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-500 drop-shadow-[0_0_12px_rgba(232,184,74,0.4)]" data-id="element-34">
                  INCLUIDOS
                </span>
                <Gift className="w-8 h-8 md:w-10 md:h-10 text-gold drop-shadow-[0_0_8px_rgba(232,184,74,0.6)]" data-id="element-35" />
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-36"></div>
              <p className="mt-4 text-lg md:text-xl text-gold font-bold uppercase tracking-widest" data-id="element-37">
                Siempre Gratis
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-38">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-b from-petroleum to-graphite border-2 border-gold rounded-2xl p-6 transition-all duration-300 relative overflow-hidden shadow-[0_0_20px_rgba(232,184,74,0.4)] hover:shadow-[0_0_35px_rgba(232,184,74,0.8)] hover:-translate-y-1" data-id="element-39">
              <div className="absolute top-0 right-0 bg-gold text-graphite font-bold px-3 py-1 rounded-bl-lg text-sm" data-id="element-40">
                Bono {bono.num}
              </div>

              <h3 className="text-lg font-bold mb-3 pr-16 text-white mt-4" data-id="element-41">
                {bono.title}
              </h3>
              <p className="text-textsecondary text-sm mb-6 min-h-[60px]" data-id="element-42">
                {bono.desc}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-43">
                <span className="text-textsecondary line-through text-sm" data-id="element-44">
                  Valor: {bono.value}
                </span>
                <span className="text-gold font-bold" data-id="element-45">GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gold/10 border border-gold/30 rounded-xl p-6 text-center" data-id="element-46">
          <p className="text-xl md:text-2xl font-bold" data-id="element-47">
            Valor total bonos:{' '}
            <span className="line-through text-textsecondary mx-2" data-id="element-48">
              $77.000
            </span>
            <span className="text-gold" data-id="element-49">→ GRATIS con tu Compra</span>
          </p>
        </motion.div>
      </div>
    </section>;
}